import { urlParams } from 'utils/request';
import { formatRFC3339 } from 'utils/time';

export default class AppointmentTimeSlotQuery {

  constructor(schedulingType, scheduleWithId, appointmentReasonUID, filterStartDate, filterEndDate, restrictToSectionId) {
    this.schedulingType = schedulingType; // 'connections' or 'services'
    this.scheduleWithId = scheduleWithId; // connection id or service id
    this.appointmentReasonUID = appointmentReasonUID;
    this.filterStartDate = filterStartDate;
    this.filterEndDate = filterEndDate;
    this.restrictToSectionId = restrictToSectionId;
  }

  get url() {
    const params = {
      appointmentReasonUID: this.appointmentReasonUID,
      startDate: formatRFC3339(this.filterStartDate),
      endDate: formatRFC3339(this.filterEndDate)
    };

    if (this.restrictToSectionId) {
      params.sectionUID = this.restrictToSectionId
    }

    return `../api/starfish/appointments/${this.schedulingType}/${this.scheduleWithId}/slots?${urlParams(params)}`;
  }

}
